import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state() {
    return {
      disabledStateBtn: false,
      currentStep: 0,
      cartHash: '',
      payment_type: 'card',
      globalLoading: false,
      cartLoading: false,
      indetifyCartLoading: false,
      theme: {
        color: null,
        image: null,
      },
      customer: null,
      stepsData: null,
      store_id: null,
      states: [],
      paymentCard: JSON.parse(localStorage.getItem('paymentCard')),
      cart: {
        payment: JSON.parse(localStorage.getItem('paymentPix')),
        customer: {
          full_name: null,
          telephone: null,
          email: null,
        },
        coupon: {
          code: null,
        },
        items: {
          bundles: [
            {
              order_bumps: [],
            },
          ],
        },
        billet: {},
        installments: [],
        subtotal: 0,
        total: 0,
      },
      disebleOrEnableAddRemove: false,
      pixels: {},
    }
  },
  getters,
  mutations,
  actions,
}
